import classNames from "classnames/bind";
import styles from './TableNotification.module.css';
import PropTypes from 'prop-types';
import { formatDateToTime } from "../../../../utils";

const cx = classNames.bind(styles)


function TableNotification({ dataNotification, getCode, fillNew }) {

    const handleClickToItemNotification = (code) => {
        getCode(code)
    }
    return (
        <table className={cx('table-notification')}>
            <thead style={{ width: '100%' }}>
                <tr>
                    <th className={cx('center')} style={{ width: "5%" }}>STT</th>
                    <th className={cx('left')} style={{ width: "15%" }}>Thời gian</th>
                    <th className={cx('left')} style={{ width: "50%" }}>Thông báo</th>
                    <th className={cx('left')} style={{ width: "20%" }}>Loại thông báo</th>
                    <th className={cx('left')} style={{ width: "10%" }}>Người nhận</th>
                </tr>
            </thead>
            <tbody className={cx('body-table')}>
                {dataNotification?.length > 0 && dataNotification.length === 0 ?
                    <></> :
                    <>
                        {dataNotification.map((item, index) => {
                            // if (item.SEEN === 0) {
                            return (
                                <tr key={index} onClick={() => handleClickToItemNotification(item?.time)}
                                    style={!item.seen ? { backgroundColor: 'rgba(0, 64, 255, 0.1)' } : {}}
                                    className={cx('new_notification')}
                                >
                                    <td className={cx('center')} style={{ width: "5%" }}>{index + 1}</td>
                                    <td className={cx('left')} style={{ width: "15%" }}>{formatDateToTime(item.time)}</td>
                                    <td className={cx('left')} style={{ width: "50%" }}>{item.detail}</td>
                                    <td className={cx('left')} style={{ width: "20%" }}>
                                        <span className={cx('tag', item.notification_type_code === 'CODE_1' && 'normal')}>{item.name}</span>
                                    </td>
                                    <td className={cx('left')} style={{ width: "10%" }}>{item.receiver}</td>
                                </tr>
                            )
                        })}

                    </>
                }
            </tbody>
        </table >
    )
}

TableNotification.propTypes = {
    dataNotification: PropTypes.array.isRequired,
    getCode: PropTypes.func,
}
export default TableNotification;